import Alert from '@material-ui/lab/Alert';
import QSTabs from "../../../../ambassador-docs/docs/pre-release/telepresence/quick-start/qs-tabs";
import QSCards from "../../../../ambassador-docs/docs/pre-release/telepresence/quick-start/qs-cards";
import * as React from 'react';
export default {
  Alert,
  QSTabs,
  QSCards,
  React
};